export enum Colors {
    Approved = '#40c463',
    Rejected = '#fa4549',
    Published = '#06b9c9',
    Archived = '#fa4549',
    Review = '#929496',
}
